import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@planuze/ui';
import type { ReactNode } from 'react';
import { usePlansContent } from '../../content/sections/plans.js';

/* Confirmação de arquivamento de plano (ADR-0704). Antes o mesmo Dialog destrutivo vivia
   duplicado em PublicSection e TargetedSection, divergindo em cópia. Agora é um único
   componente controlado: o call site guarda o alvo (`toArchive`) e passa título/descrição.
   O botão fica `loading` enquanto pendente e o Dialog trava o fechamento durante a mutação. */
export function ArchivePlanDialog({
  open,
  onOpenChange,
  isPending,
  title,
  description,
  onConfirm,
}: {
  readonly open: boolean;
  readonly onOpenChange: (open: boolean) => void;
  readonly isPending: boolean;
  readonly title: string;
  readonly description: ReactNode;
  readonly onConfirm: () => void;
}) {
  const copy = usePlansContent();
  return (
    <Dialog
      open={open}
      onOpenChange={(next) => {
        /* Não deixa fechar (Esc/overlay/X) enquanto a mutação está em voo. */
        if (!next && isPending) return;
        onOpenChange(next);
      }}
    >
      <DialogContent locked={isPending}>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="ghost" onClick={() => onOpenChange(false)} disabled={isPending}>
            {copy.common.cancel}
          </Button>
          <Button variant="destructive" loading={isPending} onClick={onConfirm}>
            {copy.archiveDialog.confirm}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
